import { BaseClass } from "./decision.model";

export class SurveyDetail extends BaseClass {
    public questionTag: string;
    public answerValue: string;
    public surveyUserId: number;
}